import React from 'react';

import { SpaceBetween, Popover, StatusIndicator, Button, Box } from '@amzn/awsui-components-react-v3';

import { ValueWithLabel } from 'src/components/Utils';
import { Model, Serial } from 'src/store/types';

interface RemainingQuanityProps {
  show: boolean;
  remainingQty: number;
}

export const remainingQtyFromModel = (model: Model, serials: Serial[]) => {
  const allSerials: Serial[] = serials?.filter((serial: Serial) => serial?.mpnIpnId === model?.mpnIpnId) || [];
  const expectedQty = model?.maximumExpectedQuantity || 0;
  const currentReceived = model?.currentReceivedQuantity || 0;
  const remainingQty = expectedQty - currentReceived - allSerials.length;

  return remainingQty;
};

export const RemainingQuanityCell = ({ remainingQty }: { remainingQty: number }) => {
  return (
    <div aria-label="remaining-qty">
      <Box margin={{ left: 'l' }}>{remainingQty < 0 ? 0 : remainingQty}</Box>
    </div>
  );
};

export const RemainingQuanity = ({ remainingQty = 0, show }: RemainingQuanityProps) => {
  if (!show) {
    return null;
  }

  return (
    <ValueWithLabel
      label={
        <SpaceBetween direction="horizontal" size="xxxs">
          <Popover
            dismissButton={false}
            position="top"
            size="small"
            triggerType="custom"
            content={
              <StatusIndicator type="info">Total number of serials remaining to receive for this MPN</StatusIndicator>
            }
          >
            <Button ariaLabel="remaining-qty-info" iconName="status-info" variant="icon" />
          </Popover>
          <Box variant="awsui-key-label">Remaining Qty.</Box>
        </SpaceBetween>
      }
    >
      <RemainingQuanityCell remainingQty={remainingQty} />
    </ValueWithLabel>
  );
};
